import '../css/Whatsapp.css'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

// O <link> pro Font Awesome inteiro (via CDN, all.css) foi removido: ele
// baixava a biblioteca de ícones completa de novo a cada render, mesmo o
// projeto já usando o pacote @fortawesome instalado (o mesmo do rodapé).
// Isso duplicava CSS e travava a renderização da página (Lighthouse
// apontava como "solicitações que bloqueiam a renderização" e "CSS não
// usado"). Agora o ícone vem do mesmo pacote já usado no Footer.js.
const WhatsAppButton = ({ zapURL }) => {
    return (
        <div className="whatsapp-container">
            <a href={zapURL} target="_blank" rel="noopener noreferrer" className="whatsapp-link" aria-label="Fale conosco pelo WhatsApp (abre em nova aba)">
                <FontAwesomeIcon icon={faWhatsapp} aria-hidden="true" className="whatsapp-icon" style={{ marginRight: 5, fontSize: 26 }} />
                <span id="texto">Fale conosco!</span>
            </a>
        </div>
    );
}

export default WhatsAppButton;
